import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import _ from 'lodash';
import React, { Component } from 'react';
import Animated from "react-native-web/dist/exports/Animated";
import TouchableOpacity from "react-native-web/dist/exports/TouchableOpacity";
import View from "react-native-web/dist/exports/View";
import PropTypes from 'prop-types';
import XDate from 'xdate';
import dateutils from "../dateutils";
import { xdateToData } from "../interface";
import styleConstructor from "./style";
import CalendarContext from "./calendarContext";
import { jsx as ___EmotionJSX } from "@emotion/core";

var commons = require("./commons");

var UPDATE_SOURCES = commons.UPDATE_SOURCES;

var iconDown = require("../img/down.png");

var iconUp = require("../img/up.png");

var TOP_POSITION = 65;

var CalendarProvider = function (_Component) {
  _inherits(CalendarProvider, _Component);

  var _super = _createSuper(CalendarProvider);

  function CalendarProvider(props) {
    var _this;

    _classCallCheck(this, CalendarProvider);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getProviderContextValue", function () {
      return {
        setDate: _this.setDate,
        date: _this.state.date,
        updateSource: _this.state.updateSource,
        setDisabled: _this.setDisabled
      };
    });

    _defineProperty(_assertThisInitialized(_this), "setDate", function (date, updateSource) {
      var sameMonth = dateutils.sameMonth(XDate(date), XDate(_this.state.date));

      _this.setState({
        date: date,
        updateSource: updateSource,
        buttonIcon: _this.getButtonIcon(date)
      }, function () {
        _this.animateTodayButton(date);
      });

      _.invoke(_this.props, 'onDateChanged', date, updateSource);

      if (!sameMonth) {
        _.invoke(_this.props, 'onMonthChange', xdateToData(XDate(date)), updateSource);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setDisabled", function (disabled) {
      if (_this.props.showTodayButton && disabled !== _this.state.disabled) {
        _this.setState({
          disabled: disabled
        });

        _this.animateOpacity(disabled);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onTodayPress", function () {
      var today = XDate().toString('yyyy-MM-dd');

      _this.setDate(today, UPDATE_SOURCES.TODAY_PRESS);
    });

    _this.style = styleConstructor(props.theme);
    _this.state = {
      date: _this.props.date || XDate().toString('yyyy-MM-dd'),
      updateSource: UPDATE_SOURCES.CALENDAR_INIT,
      buttonY: new Animated.Value(-props.todayBottomMargin || -TOP_POSITION),
      buttonIcon: _this.getButtonIcon(props.date),
      disabled: false,
      opacity: new Animated.Value(1)
    };
    return _this;
  }

  _createClass(CalendarProvider, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.date !== this.props.date) {
        this.setDate(this.props.date, UPDATE_SOURCES.PROP_UPDATE);
      }
    }
  }, {
    key: "getButtonIcon",
    value: function getButtonIcon(date) {
      if (!this.props.showTodayButton) {
        return;
      }

      var isPastDate = this.isPastDate(date);
      return isPastDate ? iconDown : iconUp;
    }
  }, {
    key: "isPastDate",
    value: function isPastDate(date) {
      var today = XDate();
      var d = XDate(date);

      if (today.getFullYear() > d.getFullYear()) {
        return true;
      }

      if (today.getFullYear() === d.getFullYear()) {
        if (today.getMonth() > d.getMonth()) {
          return true;
        }

        if (today.getMonth() === d.getMonth()) {
          if (today.getDate() > d.getDate()) {
            return true;
          }
        }
      }

      return false;
    }
  }, {
    key: "animateTodayButton",
    value: function animateTodayButton(date) {
      if (this.props.showTodayButton) {
        var today = XDate().toString('yyyy-MM-dd');
        var isToday = today === date;
        Animated.spring(this.state.buttonY, {
          toValue: isToday ? TOP_POSITION : -this.props.todayBottomMargin || -TOP_POSITION,
          tension: 30,
          friction: 8,
          useNativeDriver: true
        }).start();
      }
    }
  }, {
    key: "animateOpacity",
    value: function animateOpacity(disabled) {
      var disabledOpacity = this.props.disabledOpacity;

      if (disabledOpacity) {
        Animated.timing(this.state.opacity, {
          toValue: disabled ? disabledOpacity : 1,
          duration: 500,
          useNativeDriver: true
        }).start();
      }
    }
  }, {
    key: "renderTodayButton",
    value: function renderTodayButton() {
      var _this$state = this.state,
          disabled = _this$state.disabled,
          opacity = _this$state.opacity,
          buttonY = _this$state.buttonY,
          buttonIcon = _this$state.buttonIcon;
      var todayString = XDate.locales[XDate.defaultLocale].today || commons.todayString;
      var today = todayString.charAt(0).toUpperCase() + todayString.slice(1);
      return ___EmotionJSX(Animated.View, {
        style: [this.style.todayButtonContainer, {
          transform: [{
            translateY: buttonY
          }]
        }]
      }, ___EmotionJSX(TouchableOpacity, {
        style: [this.style.todayButton, this.props.todayButtonStyle],
        onPress: this.onTodayPress,
        disabled: disabled
      }, ___EmotionJSX(Animated.Image, {
        style: [this.style.todayButtonImage, {
          opacity: opacity
        }],
        source: buttonIcon
      }), ___EmotionJSX(Animated.Text, {
        allowFontScaling: false,
        style: [this.style.todayButtonText, {
          opacity: opacity
        }]
      }, today)));
    }
  }, {
    key: "render",
    value: function render() {
      return ___EmotionJSX(CalendarContext.Provider, {
        value: this.getProviderContextValue()
      }, ___EmotionJSX(View, {
        style: [{
          flex: 1
        }, this.props.style]
      }, this.props.children), this.props.showTodayButton && this.renderTodayButton());
    }
  }]);

  return CalendarProvider;
}(Component);

_defineProperty(CalendarProvider, "displayName", 'CalendarProvider');

_defineProperty(CalendarProvider, "propTypes", {
  date: PropTypes.any.isRequired,
  onDateChanged: PropTypes.func,
  onMonthChange: PropTypes.func,
  showTodayButton: PropTypes.bool,
  todayBottomMargin: PropTypes.number,
  todayButtonStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.array]),
  disabledOpacity: PropTypes.number
});

export default CalendarProvider;

if (typeof CalendarProvider !== 'undefined' && CalendarProvider && CalendarProvider === Object(CalendarProvider) && Object.isExtensible(CalendarProvider) && !CalendarProvider.hasOwnProperty('__filemeta')) {
  Object.defineProperty(CalendarProvider, '__filemeta', {
    configurable: true,
    value: {
      name: "CalendarProvider",
      filename: "node_modules/react-native-calendars/src/expandableCalendar/calendarProvider.js"
    }
  });
}